import React from 'react'
import { Form } from "react-bootstrap";
import { ArrowLeft } from "lucide-react";
import { ArrowRight } from "lucide-react";

const FirstSection = ({handleSubmit,formState,show,weightError,handleAnswerChangeSecond,handleAnswerChange,errors,handleCommentChange,setFormState,setStep,step,nextButton,qlen}) => {
  return (
    <Form onSubmit={handleSubmit}>
            <h3 className="h4 mb-4">
              AI Model Fairness & Performance (Evaluation Stage)
            </h3>

            {formState.filteredQuestions.filteredSectionQuestions.length > 0 ? (
              formState.filteredQuestions.filteredSectionQuestions.map(
                (question) => (
                  <div key={question.id} className="new-font mb-4  ">
                    {!question.fields.weight ? (
                      <p className="fs-5 d-flex align-items-center justify-content-start body-font">
                        {question.fields.question_text}
                      </p>
                    ) : (
                      <p
                        className="fs-5 d-flex align-items-center justify-content-start body-font"
                        style={
                          show && !weightError[question.id]
                            ? { color: "red" }
                            : { color: "black" }
                        }
                      >
                        {question.fields.question_text}*
                      </p>
                    )}

                    {question.fields.option &&
                    question.fields.option.length > 0 &&
                    !question.fields.isSingle ? (
                      <>
                        {question.fields.option.map((option, index) => (
                          <Form.Check
                            key={index}
                            type="checkbox"
                            id={`${question.id}-${option.toLowerCase()}`}
                            label={option}
                            name={question.id}
                            value={option.toLowerCase()}
                            checked={
                              formState.answers?.[question.id]?.includes(
                                option.toLowerCase()
                              ) || false
                            }
                            onChange={(e) =>
                              handleAnswerChangeSecond(
                                question.fields.weight,
                                question.id,
                                e.target.value,
                                e.target.checked
                              )
                            }
                          />
                        ))}
                      </>
                    ) : question.fields.option &&
                      question.fields.option.length > 0 &&
                      question.fields.isSingle ? (
                      <>
                        {question.fields.option.map((option, index) => (
                          <Form.Check
                            key={index}
                            type="checkbox"
                            id={`${question.id}-${option.toLowerCase()}`}
                            label={option}
                            name={question.id}
                            value={option.toLowerCase()}
                            checked={
                              formState.answers?.[question.id]?.[0] ===
                              option.toLowerCase()
                            }
                            onChange={(e) =>
                              handleAnswerChange(
                                question.fields.weight,
                                question.id,
                                e.target.value,
                                e.target.checked
                              )
                            }
                          />
                        ))}
                      </>
                    ) : (
                      <div>
                        <Form.Control
                          type="text"
                          placeholder="Type your answer here..."
                          className="input-div body-font"
                          style={{ border: "0px", background: "transparent" }}
                          value={formState.answers?.[question.id]?.[0] || ""}
                          onChange={(e) =>
                            handleAnswerChangeSecond(
                              question.fields.weight,
                              question.id,
                              e.target.value,
                              false,
                              true
                            )
                          }
                        />
                        {errors[question.id] ? (
                          <div
                            className="w-100"
                            style={{ height: "1px", backgroundColor: "red" }}
                          ></div>
                        ) : (
                          <div
                            className="w-100"
                            style={{
                              height: "1px",
                              backgroundColor: "lightgray",
                            }}
                          ></div>
                        )}
                        {errors[question.id] && (
                          <div
                            className="w-100 py-1 px-1 rounded mt-1"
                            style={{
                              backgroundColor: "#eb8b8b",
                              color: "red",
                              border: "1px solid red",
                            }}
                          >
                            {errors[question.id]}
                          </div>
                        )}
                      </div>
                    )}

                    {/* Optional Comment Box */}
                    {question.fields.option?.length > 0 &&
                      formState.answers?.[question.id]?.includes("other") && (
                        <div>
                          <Form.Control
                            type="text"
                            placeholder="Add a comment "
                            className="input-div body-font"
                            style={{ border: "0px", background: "transparent" }}
                            value={formState.comments?.[question.id] || ""}
                            onChange={(e) =>
                              handleCommentChange(question.id, e.target.value)
                            }
                          />
                          <div
                            className="w-100"
                            style={{
                              height: "1px",
                              backgroundColor: "lightgray",
                            }}
                          ></div>
                        </div>
                      )}
                  </div>
                )
              )
            ) : (
              <p>No questions found for this section.</p>
            )}
            {show && (
              <div
                className="w-100 d-flex align-items-center justify-content-center py-2 rounded"
                style={{ color: "red", fontSize: "20px" }}

              >
                ** some mandatory fields are missing **
              </div>
            )}
            <div className="d-flex align-items-center justify-content-center gap-2">
              <button
                style={{
                  backgroundColor: "#e0e0e4",
                }}
                className="w-100 py-2 rounded mt-4 text-black hover-btn"
                onClick={() => {
                  setFormState((prev) => ({
                    ...prev,
                    currentStep: "filteredQuestions",
                  }));
                  setStep(step - 1);
                }}
              >
                <ArrowLeft className="ms-3 h-2 w-2 me-2" />
                Back
              </button>

              <button
                className="w-100 py-2 rounded mt-4 border-0 text-white new-btn"
                type="submit"
                onClick={(e) =>
                  nextButton(
                    e,
                    "filteredSecondSectionQuestions",
                    qlen.filteredSec
                  )
                }
              >
                Next
                <ArrowRight className="ms-3 h-2 w-2" />
              </button>
            </div>
          </Form>
  )
}

export default FirstSection